import { bannerStyles as styles } from "@insite/content-library/Widgets/Basic/Banner";
import { mediaQueriesBP } from "@solveindustrial/Utilities/variables";

import { css } from "styled-components";

styles.overlayWrapper = {
    css: css`
        text-align: left;
        ${mediaQueriesBP.maxMD} {
            padding: 24px;
        }

        .banner-heading p,
        .banner-subheading p {
            font-size: 18px;
            line-height: 24px;
            ${mediaQueriesBP.maxMD} {
                font-size: 16px;
                line-height: 19px;
            }
        }
    `,
};
